import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Measure from "react-measure";
import { DataGrid, ProgressIndicator } from "rhombus-react";
import { useGridScrollUtils } from "utils/DataGrid";
import { MIN_GRID_HEIGHT, DEFAULT_ROW_HEIGHT } from "utils/constants";
import { CONTENT_FEED_COLUMNS } from "widgets/grid/columns/ContentFeeds";
import { ContentFeeds } from "reducers/ContentFeeds";

export default function Grid({ contentFeeds = [], libraryId, sort = "", isLoading }) {
	const dispatch = useDispatch();
	const [sortColumn, sortDirection] = sort.split(":");
	const currentSelection = useSelector(state => state.selected?.contentFeeds || []);
	const dataGridRef = useGridScrollUtils([contentFeeds]);

	const mappedContentFeeds = useMemo(() => {
		return contentFeeds.map(feed => ({
			...feed,
			libraryId,
			isSelected: currentSelection.indexOf(feed.id) > -1,
		}));
	}, [contentFeeds, libraryId, currentSelection]);

	const getRow = (rowID) => {
		if (rowID === -1) { return; }
		return mappedContentFeeds[rowID];
	};

	const dataGridProps = {
		columns: CONTENT_FEED_COLUMNS,
		rowGetter: getRow,
		rowsCount: mappedContentFeeds.length,
		rowHeight: DEFAULT_ROW_HEIGHT,
		sortColumn,
		sortDirection,
		onGridSort: (col, dir) => dispatch(ContentFeeds.setSort(col, dir)),
		enableCellAutoFocus: false,
	};

	return (
		<Measure>
			{(obj) => {
				let gridHeight = obj?.contentRect?.entry?.height || MIN_GRID_HEIGHT;
				return (
					<div className="measure-component" ref={obj.measureRef}>
						<ProgressIndicator isLoading={isLoading} />
						<div ref={dataGridRef}>
							<DataGrid
								{...dataGridProps}
								minHeight={gridHeight}
							/>
						</div>
					</div>
				);
			}}
		</Measure>
	);
}

Grid.displayName = "ContentFeedList";

